import React, { useState } from 'react';
import { Newspaper, Calendar, ArrowUpRight, ShieldCheck, X as XIcon } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from '../components/ui/dialog';
import { Button } from '../components/ui/button';

const noticias = [
  {
    id: 'forbes',
    medio: 'Forbes México',
    fecha: 'Noviembre 2025',
    tag: 'Innovación & Blockchain',
    titular: 'HITCH, la puerta de entrada a la legalidad digital',
    resumen:
      'Entrevista con el Lic. Ricardo Dehesa sobre la integración de tecnología blockchain en la práctica notarial y cómo HITCH blinda los trámites jurídicos garantizando trazabilidad e inmutabilidad documental.',
    extracto:
      'En un entorno donde la transformación digital redefine el comercio y las inversiones, la fe pública evoluciona hacia modelos criptográficos inmutables.',
    cuerpo:
      'Forbes México destaca la labor del Lic. Ricardo Dehesa Cortés al frente de la Notaría 90 y el desarrollo de HITCH, una plataforma que conecta la fe pública tradicional con protocolos de encriptación de última generación. La nota profundiza en cómo esta integración previene fraudes, agiliza validaciones notariales y sienta las bases de la legalidad digital en México.',
    enlace: 'https://forbes.com.mx/ad-hitch-la-puerta-de-entrada-a-la-legalidad-digital/',
    cta: 'Leer en Forbes',
  },
  {
    id: 'milenio',
    medio: 'Milenio',
    fecha: 'Julio 2026',
    tag: 'Liderazgo & Inversión',
    titular: 'Ricardo Dehesa, de la Notaría 90 a las nuevas inversiones digitales',
    resumen:
      'Perfil sobre el liderazgo de Ricardo Dehesa y su modelo de convergencia entre derecho, desarrollo inmobiliario y nuevos esquemas de certeza jurídica en la economía digital.',
    extracto:
      'El verdadero desafío de la economía digital ya no es la tecnología, sino la capacidad de generar confianza y certeza jurídica.',
    cuerpo:
      'En entrevista para Milenio, Ricardo Dehesa reflexiona sobre más de dos décadas de trayectoria jurídica y la evolución del notariado. Se analiza el papel del abogado y notario como diseñador de sistemas de confianza capaces de respaldar proyectos de gran escala, desarrollos inmobiliarios y esquemas de inversión innovadores en el Caribe Mexicano.',
    enlace: 'https://www.milenio.com/estilo/ricardo-dehesa-notaria-90-inversiones-digitales',
    cta: 'Leer en Milenio',
  },
  {
    id: 'inmobiliare',
    medio: 'Revista Inmobiliare',
    fecha: 'Julio 2024',
    tag: 'Sector Inmobiliario & Proptech',
    titular: 'Notaría Pública Número 90 “CERTEZA LEGAL” ofrece seguridad de blockchain',
    resumen:
      'Análisis sobre la modernización de los procesos notariales en Quintana Roo y el uso de la app HITCH para la transmisión y validación criptográfica de derechos inmobiliarios.',
    extracto:
      'La incorporación de hashes y tecnología descentralizada marca un nuevo estándar de seguridad para escrituras públicas y transacciones inmobiliarias.',
    cuerpo:
      'Inmobiliare detalla cómo la Notaría 90 implementa HITCH para vincular escrituras públicas y transmisiones de derechos a registros criptográficos consecutivos. Esta arquitectura técnica asegura que cualquier modificación requiera el consentimiento expreso del último titular registrado, blindando las operaciones inmobiliarias contra duplicidades.',
    enlace: 'https://inmobiliare.com/notaria-publica-90-certeza-legal-segurida-blockchain/',
    cta: 'Leer en Inmobiliare',
  },
  {
    id: 'comunicae',
    medio: 'Comunicae México',
    fecha: 'Febrero 2025',
    tag: 'Certeza Jurídica & Empresas',
    titular: 'La Notaría 90, liderada por Ricardo Dehesa Cortés, se consolida dentro de la seguridad jurídica',
    resumen:
      'Reportaje sobre la consolidación de la Notaría 90 como pilar de certeza para inversiones empresariales e inmobiliarias, destacando el uso de firma remota y digitalización.',
    extracto:
      'Facilitando la atracción de inversión nacional y extranjera con procesos ágiles, remotos y certificados.',
    cuerpo:
      'Comunicae subraya el papel estratégico de la Notaría 90 en Playa del Carmen y Quintana Roo para formalizar contratos comerciales, constitución de empresas y fideicomisos inmobiliarios. La nota resalta la integración de firma electrónica y canales digitales para dar máxima transparencia y celeridad a particulares y corporativos.',
    enlace: 'https://comunicae.com.mx/notas-de-prensa/la-notaria-90-liderada-por-ricardo-dehesa_1/',
    cta: 'Leer en Comunicae',
  },
  {
    id: 'excelsior',
    medio: 'Excélsior',
    fecha: 'Febrero 2025',
    tag: 'Seguridad Jurídica & Innovación',
    titular: 'La Notaría 90, liderada por Ricardo Dehesa Cortés, se consolida en la seguridad jurídica',
    resumen:
      'Publicación que aborda la seguridad jurídica y la innovación de la Notaría 90 y su papel en la modernización de los procesos notariales en Quintana Roo.',
    extracto:
      'La modernización de la fe pública consolida a la Notaría 90 como referente de certeza para inversiones y empresas.',
    cuerpo:
      'Excélsior, en colaboración con Comunicae, destaca cómo la Notaría 90, encabezada por el Lic. Ricardo Dehesa Cortés, integra innovación y seguridad jurídica para dar certeza a operaciones empresariales e inmobiliarias en el Caribe Mexicano.',
    enlace: 'https://www.excelsior.com.mx/paidpost/comunicae/la-notaria-90-liderada-por-ricardo-dehesa-cortes-se-consolida-dentro-de-la',
    cta: 'Leer en Excélsior',
  },
  {
    id: 'opportimes',
    medio: 'Opportimes',
    fecha: 'Marzo 2025',
    tag: 'Notariado & Desarrollo Empresarial',
    titular: 'Ricardo Dehesa Cortés y la influencia del notariado en el desarrollo empresarial',
    resumen:
      'Análisis sobre el papel del notariado, encabezado por Ricardo Dehesa Cortés, como motor de confianza para el desarrollo empresarial y la inversión formal.',
    extracto:
      'El notariado es un catalizador silencioso del crecimiento económico y la inversión formal.',
    cuerpo:
      'Opportimes examina la influencia de la función notarial en el ecosistema empresarial, resaltando la visión del Lic. Ricardo Dehesa Cortés sobre cómo la certeza jurídica impulsa la inversión y la formalización de negocios en México.',
    enlace: 'https://www.opportimes.com/ricardo-dehesa-cortes-y-la-influencia-del-notariado-en-el-desarrollo-empresarial/',
    cta: 'Leer en Opportimes',
  },
  {
    id: 'inmobiliare-hitch',
    medio: 'Revista Inmobiliare',
    fecha: 'Julio 2024',
    tag: 'Proptech & Blockchain',
    titular: 'Notaría Pública Número 90 ofrece seguridad mediante HITCH',
    resumen:
      'Cómo la Notaría 90 emplea la plataforma HITCH para reforzar la seguridad de los trámites y las transacciones inmobiliarias.',
    extracto:
      'HITCH aporta una capa criptográfica que eleva el estándar de seguridad de la fe pública.',
    cuerpo:
      'Inmobiliare describe la implementación de HITCH por parte de la Notaría 90 para vincular actos jurídicos con registros criptográficos, garantizando trazabilidad e integridad en las operaciones inmobiliarias de la Riviera Maya.',
    enlace: 'https://inmobiliare.com/notaria-publica-numero-90-ofrece-seguridad-mediante-hitch/',
    cta: 'Leer en Inmobiliare',
  },
  {
    id: 'inmobiliare-futuro',
    medio: 'Revista Inmobiliare',
    fecha: 'Julio 2024',
    tag: 'Innovación Digital',
    titular: 'El futuro notarial y la innovación digital: HITCH',
    resumen:
      'Reflexión, con declaraciones de Ricardo Dehesa, sobre cómo la tecnología blockchain redefine el futuro de la práctica notarial.',
    extracto:
      'La innovación digital no reemplaza la fe pública: la proyecta hacia el futuro.',
    cuerpo:
      'En esta publicación, el Lic. Ricardo Dehesa, titular de la Notaría 90, comparte su visión sobre la integración de tecnología blockchain e innovación digital en el sector notarial y sus beneficios para la certeza jurídica.',
    enlace: 'https://inmobiliare.com/el-futuro-notarial-y-la-innovacion-digital-hitch/',
    cta: 'Leer en Inmobiliare',
  },
  {
    id: 'inmobiliare-connect',
    medio: 'Inmobiliare Connect',
    fecha: 'Julio 2024',
    tag: 'Trayectoria & Proptech',
    titular: 'Notaría Pública Número 90 y HITCH',
    resumen:
      'Perfil de la Notaría 90 y sus más de 22 años de experiencia en Derecho Inmobiliario en la Riviera Maya, junto a la plataforma HITCH.',
    extracto:
      'Más de dos décadas de experiencia respaldan la apuesta de la Notaría 90 por la innovación.',
    cuerpo:
      'Inmobiliare Connect resalta la trayectoria de la Notaría 90 y su alianza con HITCH, destacando más de 22 años de experiencia en Derecho Inmobiliario al servicio de clientes nacionales e internacionales.',
    enlace: 'https://inmobiliare.com/connect/notaria-publica-numero-90-y-hitch/',
    cta: 'Leer en Inmobiliare',
  },
  {
    id: 'playacar',
    medio: 'PlayaCar Magazine',
    fecha: 'Entrevista',
    tag: 'Perfil & Trayectoria',
    titular: 'Entrevista con Ricardo Dehesa',
    resumen:
      'Entrevista sobre la trayectoria profesional del Lic. Ricardo Dehesa y la labor de la Notaría 90 en la comunidad de la Riviera Maya.',
    extracto:
      'Una conversación sobre trayectoria, vocación de servicio y el futuro de la fe pública.',
    cuerpo:
      'PlayaCar Magazine conversa con el Lic. Ricardo Dehesa sobre su trayectoria profesional, su visión del notariado y el papel de la Notaría 90 como referente de certeza jurídica en la región.',
    enlace: 'https://www.playacar.com/ricardo-dehesa-notaria-90/',
    cta: 'Leer en PlayaCar',
  },
  {
    id: 'forbes-lujo',
    medio: 'Forbes México · Lujo Descalzo',
    fecha: 'Portada',
    tag: 'Liderazgo',
    titular: 'Ricardo Dehesa y Notaría 90 en Lujo Descalzo',
    resumen:
      'Mención del Lic. Ricardo Dehesa y la Notaría 90 en la edición Lujo Descalzo de Forbes México.',
    extracto:
      'El liderazgo de la Notaría 90 llega a las páginas de Forbes México.',
    cuerpo:
      'Forbes México, en su sección Lujo Descalzo, destaca al Lic. Ricardo Dehesa y a la Notaría 90 como referentes de liderazgo y certeza jurídica en el Caribe Mexicano.',
    enlace: 'https://www.forbes.com.mx/lujo-descalzo/notaria-90',
    cta: 'Leer en Forbes',
  },
];

const Noticias = () => {
  const [selected, setSelected] = useState(null);

  return (
    <div className="min-h-screen bg-white" data-testid="noticias-page">
      {/* Hero */}
      <section className="relative py-24 bg-gradient-to-br from-notaria-primary to-notaria-secondary text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-cyan-400 rounded-full blur-3xl animate-pulse delay-700"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 text-cyan-300 font-semibold tracking-widest text-sm mb-5">
              <Newspaper className="w-4 h-4" />
              SALA DE PRENSA &amp; ACTUALIDAD JURÍDICA
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Notaría 90 en los Medios: Innovación, Seguridad Jurídica y Tecnología
            </h1>
            <p className="text-lg md:text-lg text-gray-100 max-w-3xl">
              Conoce la cobertura periodística, entrevistas y análisis especializados sobre nuestra
              trayectoria, el liderazgo del Lic. Ricardo Dehesa Cortés y la transformación digital de la
              fe pública a través del ecosistema HITCH.
            </p>
          </div>
        </div>
      </section>

      {/* Grid */}
      <section className="py-20 bg-gradient-to-br from-white to-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {noticias.map((n) => (
              <article
                key={n.id}
                data-testid={`noticia-card-${n.id}`}
                className="group flex flex-col bg-white rounded-2xl border-2 border-gray-100 hover:border-notaria-secondary shadow-sm hover:shadow-2xl transition-all duration-300 overflow-hidden"
              >
                <div className="p-7 flex flex-col flex-1">
                  <div className="flex items-center justify-between mb-5">
                    <span className="text-lg font-bold text-notaria-primary">{n.medio}</span>
                    <span className="inline-flex items-center gap-1 text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
                      <Calendar className="w-3.5 h-3.5" />
                      {n.fecha}
                    </span>
                  </div>
                  <span className="inline-block self-start bg-notaria-secondary/10 text-notaria-secondary px-3 py-1 rounded-full text-xs font-semibold mb-4">
                    {n.tag}
                  </span>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 leading-snug group-hover:text-notaria-secondary transition-colors">
                    {n.titular}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">{n.resumen}</p>
                  <div className="flex flex-wrap items-center gap-3 mt-auto pt-2">
                    <Button
                      onClick={() => setSelected(n)}
                      data-testid={`noticia-detail-btn-${n.id}`}
                      className="bg-notaria-primary hover:bg-notaria-secondary text-white"
                    >
                      Ver cobertura
                    </Button>
                    <a
                      href={n.enlace}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`noticia-external-link-${n.id}`}
                      className="inline-flex items-center gap-1 text-notaria-secondary font-semibold text-sm hover:gap-2 transition-all"
                    >
                      {n.cta}
                      <ArrowUpRight className="w-4 h-4" />
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Detail modal */}
      <Dialog open={!!selected} onOpenChange={(open) => !open && setSelected(null)}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="noticia-modal">
          {selected && (
            <>
              <DialogHeader>
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-sm font-bold text-notaria-primary">{selected.medio}</span>
                  <span className="text-xs text-gray-400">•</span>
                  <span className="text-xs text-gray-500">{selected.fecha}</span>
                </div>
                <span className="inline-block self-start bg-notaria-secondary/10 text-notaria-secondary px-3 py-1 rounded-full text-xs font-semibold mb-3">
                  {selected.tag}
                </span>
                <DialogTitle className="text-2xl font-bold text-gray-900 leading-snug text-left">
                  {selected.titular}
                </DialogTitle>
              </DialogHeader>

              <blockquote className="border-l-4 border-notaria-secondary pl-4 my-5 italic text-gray-700">
                “{selected.extracto}”
              </blockquote>

              <p className="text-gray-700 leading-relaxed mb-6">{selected.cuerpo}</p>

              <div className="flex flex-col sm:flex-row sm:items-center gap-4 border-t pt-5">
                <a
                  href={selected.enlace}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="noticia-modal-external-link"
                  className="inline-flex items-center justify-center gap-2 bg-notaria-primary hover:bg-notaria-secondary text-white px-6 py-3 rounded-lg font-semibold transition-colors"
                >
                  {selected.cta}
                  <ArrowUpRight className="w-4 h-4" />
                </a>
                <span className="inline-flex items-center gap-1.5 text-xs text-gray-500">
                  <ShieldCheck className="w-4 h-4 text-green-600" />
                  Enlace verificado
                </span>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Noticias;
